<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'list'" class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter ref="emListFilter" :entity="modelName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryDeliveryTaskResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table ref="emTable"
                        :entity="modelName"
                        :inlineActionsDisabled="prop_inline!=='1'" withCustomRowActions
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                <template #left-header>
                  <b-button
                      :disabled="actionDisabled('select')"
                      size="sm"
                      variant="outline-primary"
                      @click="openUpdateStatus()"
                  >
                    批量更改物流状态
                  </b-button>
                </template>
                <template #customRowActions="{row}">
                  <b-button-group>
                    <em-button type="gotoChild"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="gotoChild(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

    <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="updateStatusVisible" title="批量更改物流状态"
               width="30%" @close='clearUpdateStatus'>
      <el-form ref="updateStatusForm" :model="updateStatusForm" :rules="updateStatusRules" label-width="auto">
        <el-form-item label="物流状态" prop="logisticsStatus">
          <el-select v-model="updateStatusForm.logisticsStatus" placeholder="请选择">
            <el-option
                v-for="deliveryStatus in deliveryStatusOptions"
                :key="deliveryStatus.value"
                :label="deliveryStatus.label"
                :value="deliveryStatus.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateStatusVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateStatus()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// Author Lin
// Date 2021-05-24 20:46:26

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
  name: "sithMesInventoryDeliveryTaskListView",
  mixins: [emCommonListMixin, emCommonGotoMixin, emCommonApiMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      //物流状态，后端对应DeliveryStatusEnum
      deliveryStatusOptions: [
        {value: '1', label: '已申请'},
        {value: '2', label: '已核对接收'},
        {value: '3', label: '待包装'},
        {value: '4', label: '已退回'},
        {value: '5', label: '已包装'},
        {value: '6', label: '已盘点'},
        {value: '7', label: '已拆箱'},
        {value: '8', label: '已装车待发货'},
        {value: '9', label: '已发货'},
        {value: '10', label: '已通知库房点件'},
      ],
      updateStatusVisible: false,
      updateStatusForm: {
        logisticsStatus: ''
      },
      updateStatusRules: {logisticsStatus: [{required: true, message: '请选择物流状态！'}]},
    }
  },
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    checkedItems() {
      return this.$store.state[this.modelName]["checkedItems"];
    },
    selectIds() {
      return this.$store.state[this.modelName]["checkedItems"].join(",");
    },
  },
  methods: {
    gotoChild(row) {
      this.$_emGotoMixin_gotoHolderList("sithMesInventoryDeliveryMaterial"
          , {deliveryTaskIdFilter: row.id}
          , {deliveryTaskId: row.id}, false, {})
    },

    //根据按钮上设置的选中类型和实际列表中选中的项目，判断按钮是否可点
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    openUpdateStatus() {
      this.updateStatusVisible = true;
    },
    clearUpdateStatus() {
      this.updateStatusForm.logisticsStatus = ''
    },
    batchUpdateStatus() {
      let self = this;
      this.$refs["updateStatusForm"].validate(valid => {
        if (valid) {
          let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/batchUpdateStatus?ids=${this.selectIds}&logisticsStatus=${self.updateStatusForm.logisticsStatus}`
          self.$_emApiMixin_post(url, {})
              .then(response => {
                if (response.status === 200) {
                  self.$message({
                    message: "更新成功",
                    type: "success",
                  });

                  self.$refs.emListFilter.doQuery();
                } else {
                  self.$message({
                    message: "更新失败",
                    type: "error",
                  });
                }
              })
              .finally(() => this.updateStatusVisible = false)
        } else {
          self.$message({
            message: "数据不完整",
            type: "error",
          });
          return;
        }
      })
    },
  },
  mounted() {
    if (this.$route.query.hasOwnProperty("id")) {
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
    }
    this.$refs.emListFilter.doQuery();
  }
};
</script>
